import script from "./emptyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./emptyTable.vue?vue&type=script&setup=true&lang=js"

import "./emptyTable.vue?vue&type=style&index=0&id=47a2e818&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a2e818"]])

export default __exports__